<template lang="pug">
  .agv-ri-discount
    span(v-if="renter.discount_calc_type === 'manual'")
      | {{percentage(renter.rent_discount)}}
    span(v-else-if="renter.discount_calc_type === 'progressive'")
      | {{percentage(renter.rent_discount)}}–{{percentage(renter.rent_discount) + 10}}
    span(v-else-if="renter.discount_calc_type === 'pifakit_progressive'")
      | 30–40
    | %
    |
    | на аренду
    div(v-if='renter.is_delivery_offered')
      | {{renter.service_discount | percentage}} на доставку
</template>

<script>
  export default {
    name: 'agv-ri-discount',
    props: {
      renter: Object
    },
    methods: {
      percentage(value) {
        return Math.round(value * 100)
      }
    }
  }
</script>

<style scoped>

</style>
